import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'gold' | 'success' | 'danger' | 'info';

const TONES: Record<BadgeTone, string> = {
  neutral: 'border-ink-border bg-ink-overlay text-slate-300',
  gold: 'border-gold-700 bg-gold-900/60 text-gold-200',
  success: 'border-success/30 bg-success-soft text-emerald-300',
  danger: 'border-danger/30 bg-danger-soft text-red-300',
  info: 'border-sky-800 bg-sky-950 text-sky-300',
};

// Status pill — matches the production app's `.status-pill` treatment.
// Used for job stages, estimate/invoice status, account status, etc.
export function Badge({ children, tone = 'neutral', className = '' }: { children: ReactNode; tone?: BadgeTone; className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${TONES[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
